import {withTranslation} from "react-i18next";
import SummaryTemplate from "./SummaryTemplate";
import React from "react";
import {parseElectric} from "../parsers";
import {makeExtractKeys} from "../../../../utils/FarmMapUtils";
import GlobalConfig from "./GlobalConfig";

const getKeys = makeExtractKeys();

function ElectricSummary({devices, data, t}) {
    const result = [];
    const keys = getKeys(devices);
    for (let key of keys) {
        const {isLive, text} = parseElectric(data[key]);
        result.push(
            <SummaryTemplate
                icon={"fas fa-wheat"}
                header={t(
                    "deviceRows.electricityFlowMeter.electricityFlowMeterRow.electricityConsumedToday"
                )}
                alerts={data[key]?.Alerts}
                warnings={data[key]?.Warnings}
                isWarning={
                    GlobalConfig.SHOW_OUTDATED_AS_WARNING ? !isLive : false
                }
                content={text}
            />
        );
    }
    return result;
}

export default withTranslation()(ElectricSummary);
